import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutOrderTypeQuickInfo } from "./autogen/AutogenLayoutOrderTypeQuickInfo";

export class OrderTypeQuickInfo extends AutogenLayoutOrderTypeQuickInfo {

    sourceOrderTypeAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxId.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/dispatch/OrderType",
            event.data?.get("id")
        );
        this.panelColorDisplay.backgroundColor = event.data?.get("planning_hex_color");
        this.panelColorDisplay.tooltip = event.data?.get("planning_hex_color");
    }
}
